import { BrightcoveVideo } from "@ww-digital/web-palette-react/dist/components/Video/BrightcoveVideo/BrightcoveVideo";
import { AsHtml } from "../../utils/translate";
import styles from "./styles.module.scss";
import t from "../../utils/translate";

const AsHtmlWithVideos = ({ value, className, interpolations }) => {
  if (process.env.REACT_APP_VIDEO_OFF === "true")
    return (
      <AsHtml
        className={className}
        value={value}
        interpolations={interpolations}
      />
    );

  const videoRegEx = /\[video:\d+\]/g;
  const textParts = value.split(videoRegEx);
  const videoParts = value.match(videoRegEx);

  const result = [];
  for (let i = 0; i < textParts.length; i++) {
    if (textParts[i] !== "") {
      result.push(
        <AsHtml
          key={i * 2}
          className={className}
          value={textParts[i]}
          interpolations={interpolations}
        />
      );
    }
    if (videoParts && videoParts[i]) {
      const videoId = videoParts[i].match(/\d+/)[0];
      result.push(
        <div className={styles.videoWrapper + " videoWrapper"} key={i * 2 + 1}>
          <BrightcoveVideo
            playTitle=""
            pauseTitle=""
            accountId={t("BRIGHTCOVE_VIDEO_ACCOUNT_ID")}
            playerId={t("BRIGHTCOVE_VIDEO_PLAYER_ID")}
            videoId={videoId}
          />
        </div>
      );
    }
  }
  return result;
};

export default AsHtmlWithVideos;
